<template>
  <div class="content">
    
      <div class="container-fluid mt-4">

          <stats-card title="Overview" type="default" sub-title="Greetings, Earthling!" icon="fas fa-tachometer-alt">

            <template slot="append">

              <div class="tab-container">
                <div class="row">

                  <div class="col col-4">
                    <div class="mt-4">
                      <p>Welcome to <strong>RapidAIM's Control Panel</strong>, where pests bite the dust and customer / grid management is made easy.</p>
                      <p>Please slack Tom or Ella if you stumble upon a bug or have suggestions for improvement.</p>
                      <p class="small mt-5">Made with love &amp; coffee by Tom + Ella</p>
                    </div>
                  </div>

                  <div class="col col-8">
                    <stats-card title="Grid health" sub-title="Traps status">

                      <template slot="append">

                        <base-alert>Click on a particular status to display a list of matching traps</base-alert>

                        <div v-if="chartData.length > 0">
                          <GChart
                            :settings="{ packages: ['corechart'], mapsApiKey: 'AIzaSyDT0mhzmZrzy_eG4kZJ5LZ3cipRbJVDVKY' }"
                            type="BarChart"
                            :data="chartData"
                            :options="chartOptions"
                            :events="chartEvents"
                          />
                        </div>
                      </template>
                    </stats-card>
                  </div>
                </div>
                  
            </div>

              

            </template>

          </stats-card>

      </div>
      
  </div>
</template>

<style></style>

<script>
import { GChart } from 'vue-google-charts'
import BaseHeader from '@/components/BaseHeader'
import BaseProgress from '@/components/BaseProgress'
import StatsCard from '@/components/Cards/StatsCard'
import api from '@/api'
import { StatusMap, SubStatusMap } from '@/config/SensorStatuses';
import { PersistentListFilter } from '@/helpers/PersistentListFilter'
import { SensorStatusHelper } from '@/helpers/SensorStatusHelper';

export default {
  components: {
    GChart,
    BaseHeader,
    BaseProgress,
    StatsCard
  },
  created: async function() {
    this.fetchSensorsStatus()
  },
  methods: {
    fetchSensorsStatus: async function() {
      this.$emit('loading', true);
      this.sensorStatuses = await api.getSensorStatusAll()
      this.buildChartData()
      this.$emit('loading', false);
    },
    buildChartData() {
      this.chartData = this.sensorStatuses.map((s) => [
        SensorStatusHelper.getDescription(s), parseInt(s.count), SensorStatusHelper.getColourHex(s.status), s.count
      ])
      this.chartData = [
        ['Status', 'Tally', { role: 'style' }, { role: 'annotation' } ],
        ... this.chartData  
      ]
    },
    buildChartColours() {
      let output = {}
      let cnt = 0
      for(let status of this.sensorStatuses) {
        output[cnt] = {
          color: `${SensorStatusHelper.getColourHex(status.status)}`
        } 
        cnt++
      }
      this.chartOptions.slices = output
    }
  },
  data() {
    return {
      sensorStatuses: [],
      gridHealth: [],
      chartData: [],
      chartColours: {},
      chartEvents: {
        'click': (id) => {
          let matches = id.targetID.match(/#([0-9]+)$/)
          let index = parseInt(matches[1]) + 1
          let description = this.chartData[index][0]
          let matchedStatus = this.sensorStatuses.filter((s) => SensorStatusHelper.getDescription(s) == description)[0]
          let pf = new PersistentListFilter('sensors')
          pf.persistFilter(StatusMap[matchedStatus.status])
          this.$router.push(`/sensors`);
        }
      },
      chartOptions: {
        legend: {
          position: 'none'
        },
        height: 600,
        backgroundColor: '#FCFCFC',
        chartArea: {
          left: 300
        }
      }
    };
  }
};
</script>
